module.exports = __webpack_public_path__ + "static/media/15.4a79e45f.gif";